import React from 'react';
import PropTypes from 'prop-types';
import CountryDropdown from './CountryDropdown';
import { defaultLocale } from 'dibs-intl/exports/constants';
import get from 'lodash.get';
import { injectIntl, intlShape, defineMessages } from 'react-intl';
import SV from 'server-vars';

const intlCountries = defineMessages({
    'en-US': {
        id: 'dbl.country.usa',
        defaultMessage: 'United States',
    },
    'en-GB': {
        id: 'dbl.country.uk',
        defaultMessage: 'United Kingdom',
    },
    'de-DE': {
        id: 'dbl.country.germany',
        defaultMessage: 'Germany',
    },
    'fr-FR': {
        id: 'dbl.country.france',
        defaultMessage: 'France',
    },
});

class CountrySelector extends React.Component {
    handleCountryChange(linkToRedirect) {
        const { location } = window;
        location.assign(linkToRedirect);
    }

    getCountries() {
        const { intl, isClient } = this.props;
        const defaultDomainsLinks = SV.get('defaultDomainsLinks');
        const domains = isClient ? SV.get('domainLinks') : defaultDomainsLinks;
        const domainLinks = domains || defaultDomainsLinks || [];

        return domainLinks.map(countryLink => {
            let hrefLang = get(countryLink, 'hrefLang');
            if (hrefLang === 'en') {
                hrefLang = defaultLocale;
            }
            return {
                link: get(countryLink, 'href'),
                country: intl.formatMessage(get(intlCountries, `${hrefLang}`)),
            };
        });
    }

    render() {
        const { intl, isClient } = this.props;

        if (isClient) {
            const countries = this.getCountries();
            const countryMessage = intlCountries[SV.get('locale')] || intlCountries[defaultLocale];
            return (
                <CountryDropdown
                    onChange={this.handleCountryChange.bind(this)}
                    countries={countries}
                    country={intl.formatMessage(countryMessage)}
                />
            );
        } else {
            return null;
        }
    }
}

CountrySelector.propTypes = {
    intl: intlShape.isRequired,
    isClient: PropTypes.bool,
};

CountrySelector.defaultProps = {
    isClient: false,
};

export default injectIntl(CountrySelector);
